import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { VesselType } from "@/app/services/generated/vesseltypeService";
import { vesselTypeService } from "@/app/services/generated/vesseltypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasVesselTypesCache {
  vesselTypes: VesselTypesCache;
}

// Singleton cache store
const vesselTypesCacheStore = new EntityCacheStore<VesselType>(
  EnumCacheEntityType.vesselType,
  async () => vesselTypeService.getAllVesselTypes()
);

// Ephemeral reader
export default class VesselTypesCache extends EntityWithGuidKeyCache<VesselType> {
  constructor() {
    super(vesselTypesCacheStore, (x) => x.id);
  }
}
